// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__crQTM","title":"Images90_title__1-h71","images":"Images90_images__12zEe"};